export const START = 'START'
export const OPEN_MENU = 'OPEN_MENU'
export const CLOSE_MENU = 'CLOSE_MENU'
export const WINDOW_RESIZE = 'WINDOW_RESIZE'
export const ORIENTATION_CHANGE = 'ORIENTATION_CHANGE'
export const USER_SCROLL = 'USER_SCROLL'
export const ENABLE_LIGHT_MODE = 'ENABLE_LIGHT_MODE'
export const DISABLE_LIGHT_MODE = 'DISABLE_LIGHT_MODE'
export const CART_UPDATED = 'CART_UPDATED'
export const OPEN_CART = 'OPEN_CART'
export const CLOSE_CART = 'CLOSE_CART'
export const CART_LOADING = 'CART_LOADING'
export const CART_LOADING_FINISH = 'CART_LOADING_FINISH'
export const VARIANT_CHANGE = 'VARIANT_CHANGE'
export const SELECT_SS_CATEGORY = 'SELECT_SS_CATEGORY'
export const DESELECT_SS_CATEGORY = 'DESELECT_SS_CATEGORY'
export const OPEN_QUICK_BUY = 'OPEN_QUICK_BUY'
export const CLOSE_QUICK_BUY = 'CLOSE_QUICK_BUY'
export const OPEN_AFTERPAY = 'OPEN_AFTERPAY'
export const CLOSE_AFTERPAY = 'CLOSE_AFTERPAY'


export const SHOPIFY_UPDATE_ELEMENT = 'SHOPIFY_UPDATE_ELEMENT'
